import { render, staticRenderFns } from "./addbeforeLogin.vue?vue&type=template&id=131d46d4&"
import script from "./addbeforeLogin.vue?vue&type=script&lang=js&"
export * from "./addbeforeLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('131d46d4')) {
      api.createRecord('131d46d4', component.options)
    } else {
      api.reload('131d46d4', component.options)
    }
    module.hot.accept("./addbeforeLogin.vue?vue&type=template&id=131d46d4&", function () {
      api.rerender('131d46d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/announcement/components/addbeforeLogin.vue"
export default component.exports